import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import './index.css'
import 'typeface-roboto'
import AppRouter from './containers/AppRouter'
import registerServiceWorker from './registerServiceWorker'
import createStore from './redux/store'
import firebase from 'firebase'
import { firebaseSignin, firebaseSignout } from './services/signin/actions'
import {
  firebaseNoteAdded,
  firebaseNoteUpdated,
  firebaseNoteDeleted
} from './services/notes/actions'
import firebaseConfig from './firebaseConfig'

firebase.initializeApp(firebaseConfig)

const store = createStore()

firebase.auth().onAuthStateChanged(user => {
  if (user) {
    watchUserNotes(user)
    store.dispatch(firebaseSignin(user))
  } else {
    store.dispatch(firebaseSignout())
  }
})

function watchUserNotes(user) {
  const notesRef = firebase.database().ref('users/' + user.uid + '/notes')
  notesRef.on('child_added', data => {
    store.dispatch(firebaseNoteAdded({ key: data.key, note: data.val() }))
  })
  notesRef.on('child_changed', data => {
    store.dispatch(firebaseNoteUpdated({ key: data.key, note: data.val() }))
  })
  notesRef.on('child_removed', data => {
    store.dispatch(firebaseNoteDeleted({ key: data.key }))
  })
}

ReactDOM.render(
  <Provider store={store}>
    <AppRouter />
  </Provider>,
  document.getElementById('root')
)
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js